/* eslint-disable import/no-mutable-exports */
import React from 'react';
import { Center, Image } from '@chakra-ui/react';
import { TTemplate } from '@/helpers/createTemplate';
import emptyBetslip from '../../../../../../../assets/wellbet/images/emptyBetslip.svg';

export const template: TTemplate = {
  wrapper: <Center />,
  empty: <Image src={emptyBetslip} h="40" mb="3" />,
};

export default template;
